import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('AppUser')

export default {
  label: 'AppUser',
  route: 'appuser',
  className: 'appUser',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.UnsortableReference('applicationRoles', true),
    ListFields.SortableField('userName', true),
    ListFields.SortableField('email', false),
    ListFields.SortableBoolean('forscher', false),
    ListFields.UnsortableReference('organisationseinheiten', false),
    ListFields.UnsortableReference('zstzlOrganisationseinheiten', false),
    ListFields.SortableTimestamp('lastLogin', true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/AppUser.js